import { useCallback, useEffect, useState } from "react";
import { Alert, FormControlLabel, Paper, Stack, Switch, Typography } from "@mui/material";

/**
 * The takeover switch. On, this app's agent answers unanswered texts on the
 * hourly timer, as this app and inside its reviewed manifest.
 */
export default function TakeoverPanel({ own }) {
  const [state, setState] = useState(null);
  const [failure, setFailure] = useState(null);

  const load = useCallback(async () => {
    try {
      setState(await own("/takeover"));
      setFailure(null);
    } catch (e) {
      setFailure(e);
    }
  }, [own]);

  useEffect(() => { load(); }, [load]);

  async function toggle(enabled) {
    try {
      setState(await own("/takeover", { method: "PUT", body: JSON.stringify({ enabled }) }));
      setFailure(null);
    } catch (e) {
      setFailure(e);
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(state?.enabled)}
              disabled={!state}
              onChange={(e) => toggle(e.target.checked)}
              slotProps={{ input: { "aria-label": "let the agent reply for me" } }}
            />
          }
          label={state?.enabled ? "Agent is on \u2014 replying for you" : "Agent is off \u2014 you are replying"}
        />
        <Typography variant="body2" color="text.secondary">
          Turn this on when you can't respond. Once an hour the agent replies to any
          conversation whose latest text is unanswered, from your Twilio number, as an
          automated assistant, and says a person will follow up. It recognises a sender by
          matching their number against the phones of every Person. A reply can be up to an
          hour late.
          {state?.updated_by ? ` Last changed by ${state.updated_by}${state.updated_at ? ` at ${new Date(state.updated_at).toLocaleString()}` : ""}.` : ""}
        </Typography>
        {failure ? (
          <Alert severity="error" variant="outlined">
            The switch could not be {state ? "changed" : "read"}.
          </Alert>
        ) : null}
      </Stack>
    </Paper>
  );
}
